var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout_basic"},[_c('div',{staticClass:"layout_panel main"},[_c('router-view')],1),_vm._l((_vm.$store.state.dialogStack),function(item,index){return _c('Dialog',{key:index,attrs:{"config":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }